import apiClient from "./config";
import { RETIREMENT_CALCULATOR } from "./endpoints";

const RetirementCalculatorService = {
    // Get Search Results
    getRetireCalData: (payload) => {
        return apiClient.post(RETIREMENT_CALCULATOR.GET_RETIREMENT, payload);
    }
};

export default RetirementCalculatorService;